import { createSelector } from '@reduxjs/toolkit';
import { selectors as dataGridTableSelectors } from '../Modules/dataGridTable';
import { getGlobalDepartments } from 'utils/personnelHelper';
import { getGlobalDepartmentRecords } from 'selectors/globalSelectors';
import { transformList } from 'utils/DataTransform/BusinessClients/BusinessClientList';
import { selectors as filtersSelectors } from '../Modules/filters';
import { transform } from 'utils/DataTransform/BusinessClients/BusinessClientDetailsDataTransform';
import { selectors as embeddedFormSelectors } from 'modules/embeddedForms/reducer';
import isEmpty from 'lodash/isEmpty';
import { transformRawClient } from 'utils/DataTransform/Clients/ClientList';

export const getBusinessClientListTransformed = createSelector(
  dataGridTableSelectors.getGridTableList,
  getGlobalDepartmentRecords,
  (businessClientList, globalDepartmentRecords) => {
    if (!businessClientList) {
      return [];
    }
    const globalDepartmentList = getGlobalDepartments(globalDepartmentRecords);
    return transformList(businessClientList, globalDepartmentList);
  },
);

export const getTotalEntries = createSelector(
  dataGridTableSelectors.getTotalGridRows,
  rowsCount => {
    if (!rowsCount) {
      return 0;
    }
    return rowsCount;
  },
);
// status of list refresh
export const getForceRefresh = createSelector(
  dataGridTableSelectors.getForceRefresh,
  forceRefresh => forceRefresh,
);

export const getBusinessClientFilters = createSelector(
  filtersSelectors.getFilterValues,
  filterValues => {
    return filterValues;
  },
);

export const getSelectedRowID = createSelector(
  dataGridTableSelectors.getSelectedRowID,
  selectedRowID => selectedRowID,
);

// gets the transformedBusinessClientDetails
export const getBusinessClientDetailsTransformed = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  getGlobalDepartmentRecords,
  (details, globalDepartmentRecords) => {
    if (!details) {
      return {};
    }
    // convert it into id and name list array
    const globalDepartmentList = getGlobalDepartments(globalDepartmentRecords);
    return transform(details, globalDepartmentList);
  },
);
// gets the raw BusinessClientDetails
export const getBusinessClientDetailsRaw = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  details => {
    if (!details) {
      return {};
    }

    return details;
  },
);

// embedded selectors
export const customerEmbeddedDetails = createSelector(
  embeddedFormSelectors.getCustomersEmbeddedFormDetails,
  details => {
    if (isEmpty(details)) {
      return {};
    }

    const [detail] = transformRawClient([details]);
    return detail;
  },
);
